import React from "react";
import YellowDivider from "../../dividers/YellowDivider";
import AboutCard from "../ourjourney/AboutCard";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { ReactComponent as SkyRocketLine } from "../../../assets/skyrocket-line.svg";
import "../../../stylesheet/components/about/skyrocket/SkyRocket.scss";

const SKY_ROCKET_ITEMS = {
  en: [
    {
      title: "Soft Launch",
      body: "Zefi was founded in 2020, and since then we were establishing our ecosystem with one goal in mind: To offer an inclusive platform to everyone interested in building their knowledge and awareness in the blockchain space. Here we are now, the core features of our new website are live, with more to come. Couldn’t be more excited!",
    },
    {
      title: "Sneak Peek",
      body: "Take a glimpse into ZeFi both ongoing and upcoming projects that we’re super excited about:  Media production, academic courses, technical glossary, workshops & seminars, capacity building programs, books, research papers & publications, community-led initiatives, and much more to be announced later on.",
    },
  ],
  ar: [
    {
      title: "المرحلة التجريبيّة",
      body: "منذ العام 2020، سنة تأسيس زيفاي، ونحن نعمل على تقديم منصّة حاضنة لجميع المهتمّات والمهتمّين في بناء معرفتهنّ/م حول فضاء البلوكتشين، وزيادة وعيهنّ/م به. نطلق اليوم الميزات الأساسيّة في موقعنا الإلكترونيّ الجديد، ويغمرنا الحماس للعمل على المزيد في الأيّام القادمة!",
    },
    {
      title: "نظرة على ما يحدث",
      body: "نتطلّع لتقديم العديد من المشاريع التي قد تساهم في تحسين حياة الكثيرات والكثيرين منّا؛ من إنتاج إعلاميّ، ودورات أكاديميّة، وقاموس متخصّص إلى العديد من ورش العمل والمؤتمرات، وبرامج التمكين، والكتب، والأوراق البحثيّة، والمنشورات المتنوّعة... كما أنّنا بصدد إطلاق مبادرات مجتمعيّة ومشاريع متنوّعة سنعلن عنها تباعاً.",
    },
   
  ],
};

const SkyRocket: React.FC = () => {
  const { ready, t, i18n } = useTranslation();

  const getJourneyItems = () => {
    if (i18n.language === "ar") {
      return SKY_ROCKET_ITEMS.ar.map((item) => (
        <AboutCard
          key={`skyrocket-item-${item.title
            .replaceAll(" ", "-")
            .toLowerCase()}`}
          title={item.title}
          body={item.body}
        />
      ));
    }
    return SKY_ROCKET_ITEMS.en.map((item) => (
      <AboutCard
        key={`skyrocket-item-${item.title.replaceAll(" ", "-").toLowerCase()}`}
        title={item.title}
        body={item.body}
      />
    ));
  };

  return (
    <>
      <div className="mb-3 mb-lg-4">
        <h2>
          {ready ? t("about-zefi.sky-rocket.title") : <Skeleton width={350} />}
        </h2>
        <YellowDivider heading="h2" />
      </div>
      <div className="sky-rocket-outer">
        <SkyRocketLine className="sky-rocket-line" />
        {getJourneyItems()}
      </div>
    </>
  );
};

export default SkyRocket;
